import { NavigationFlow } from "../../common/flow";
import type { PackageSteps } from "./PackageNavigationFlowProvider";

const useGoToNextStep = (currentStep: PackageSteps) => {
  return NavigationFlow.useGoToNextStep<PackageSteps>(currentStep);
};

const useGoToStep = () => {
  return NavigationFlow.useGoToStep<PackageSteps>();
};

const useGetStepRoute = (step: PackageSteps) => {
  return NavigationFlow.useGetStepRoute<PackageSteps>(step);
};

export const PackageNavigationFlow = {
  useGoToNextStep,
  useGoToStep,
  useGetStepRoute,
};
